import { CheckCircle2 } from "lucide-react";

function getCircleClasses(active, done) {
  if (active) return "bg-blue-500 border-blue-500 text-white pulse-blue";
  if (done)   return "bg-blue-500/20 border-blue-500 text-blue-400";
  return "border-slate-700 text-slate-500";
}

function getLabelClasses(active, done) {
  if (active) return "text-slate-100";
  if (done)   return "text-blue-400";
  return "text-slate-500";
}

export default function StepIndicator({ steps, currentStep }) {
  return (
    <div className="flex items-center gap-2 sm:gap-3 mb-8">
      {steps.map((s, i) => {
        const active = currentStep === s.id;
        const done = currentStep > s.id;
        return (
          <div key={s.id} className="flex items-center gap-2 sm:gap-3 flex-1 min-w-0">
            <div className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center text-xs font-mono-data border ${getCircleClasses(active, done)}`}>
              {done ? <CheckCircle2 size={14}/> : s.id}
            </div>
            <div className={`text-sm hidden md:block truncate ${getLabelClasses(active, done)}`}>{s.label}</div>
            {i < steps.length - 1 && <div className={`flex-1 min-w-0 h-px ${done ? "bg-blue-500/40" : "bg-slate-700"}`}/>}
          </div>
        );
      })}
    </div>
  );
}
